<template>
       <footer class="main-footer">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-section">
            <h4>AI算力之门</h4>
            <p>专业的AI算力服务提供商</p>
            <p>让AI触手可及</p>
          </div>
          <div class="footer-section">
            <h4>产品</h4>
            <ul>
              <li><router-link to="/products#power-rent">轻量级算力租赁</router-link></li>

              <li><router-link to="/products#container">预装框架容器</router-link></li>
              <li><router-link to="/products#model-service">零部署模型服务</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>解决方案</h4>
            <ul>
              <li><router-link to="/solutions#education">教育行业</router-link></li>
              <li><router-link to="/solutions#design">设计工作室</router-link></li>
              <li><router-link to="/solutions#performance">行业性能对比</router-link></li>
              <li><router-link to="/solutions#technology">多样的大模型场景</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系我们</h4>
            <p>商务咨询：18118868998</p>
            <!-- <p>地址: 北京市朝阳区AI科技园</p> -->
            <img  src="@/assets/wechat.png"  alt="logo" class="chat-img" height="100" width="100" style="display: block;margin-top: 5px;border-radius: 10px;" />
          </div>
        </div>
        <div class="footer-bottom">

          <a class="footer-bottom-item" href="https://beian.miit.gov.cn/" target="_blank">工信部备案号：苏ICP备13013536号-26</a>
          <a class="footer-bottom-item" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32028102003325" target="_blank" :style="{display: 'flex', alignItems: 'center', gap: '1px'}"><img src="@/assets/ga.png" alt="公安部备案号" style="width: 11px; height: 11px;" />公安部备案号：苏公网安备32028102003325号 </a>
          <span class="footer-bottom-item" >Copyright © 2025 AI算力之门. All rights reserved.</span>
        </div>
      </div>
    </footer>
</template>
<script>  
export default {
    name: 'Footer-node',
}
</script>
<style scoped lang="scss">
.main-footer {
  background: #000;
  padding: 60px 20px 20px;
  // border-top: 1px solid rgba(255, 255, 255, 0.1);

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-section {
    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    p {
      color: #8892b0;
      line-height: 1.6;
      margin: 0 0 8px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 8px;

        a {
          color: #8892b0;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: #667eea;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    gap: 20px;
    .footer-bottom-item {
      color: #8892b0;
      margin: 0;
    }
  }
}


</style>